var map = {
	"./Chinese-literature.svg": 135,
	"./bookmark.svg": 136,
	"./calculus.svg": 137,
	"./elementary-math.svg": 138,
	"./higher-mathematics.svg": 139,
	"./mock-exam.svg": 140,
	"./photo.png": 73,
	"./photo.svg": 141,
	"./secondary-math.svg": 142,
	"./trash.png": 74,
	"./workbook.svg": 143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;